export const GRANT_TYPES = {
    EMAIL_TOKEN: "email_token",
    SMS_CODE: "sms_code",
    REFRESH_TOKEN: "refresh_token",
    AUTHORIZATION_CODE: "authorization_code",
};

export const CONTENT_TYPES = {
    X_WWW_FORM_URLENCODED: "application/x-www-form-urlencoded",
    APPLICATION_JSON: "application/json",
};

export const getClientId = (): string => window.APP_SETTINGS.clientId;
export const getClientSecret = (): string => window.APP_SETTINGS.clientSecret;
